<template>
  <el-container class="avue-contail">
    <el-header height="auto" class="avue-header">
      <!-- 顶部导航栏 -->
      <top class="avue-top"/>
    </el-header>

    <el-container class="avue-layout">
      <el-aside class="avue-left" :style="{ display: isCollapse ? 'none' : 'block' }">
        <!-- 左侧导航栏 -->
        <el-scrollbar style="height:100%">
          <sidebar class="avue-sidebar"></sidebar>
        </el-scrollbar>
      </el-aside>
      <el-main class="avue-main">
        <!-- 顶部标签卡 -->
        <tags @closeSildebar="handleChange"  />
        <!-- 主体视图层 -->
        <el-scrollbar style="height:100%">
          <keep-alive>
            <router-view class="avue-view" v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view class="avue-view" v-if="!$route.meta.keepAlive" />
        </el-scrollbar>
      </el-main>
    </el-container>
    <el-footer class="avue-footer">
      <p class="copyright">© 2017-{{nowYear}}成都聚家科技有限公司</p>
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import tags from "./tags";
import top from "./top/";
import sidebar from "./sidebar/";
import { validatenull } from "@/util/validate";
import { calcDate } from "@/util/date.js";
import { getStore } from "@/util/store.js";
export default {
  components: {
    top,
    tags,
    sidebar,
  },
  name: "index",
  data() {
    return {
      //刷新token锁
      refreshLock: true,
      //刷新token的时间
      refreshTime: "",
      imInitData: {},
      tokenData: {},
      nowYear: new Date().getFullYear(),
    };
  },
  created() {
    //实时检测刷新token
    this.refreshToken();
    this.$store.dispatch("setDsrms");
  },
  mounted() {},
  computed: mapGetters(["isLock", "isCollapse", "website"]),
  props: [],
  methods: {
    handleChange() {
      // 控制左侧菜单栏的显示隐藏
      // this.isCollapse = !this.isCollapse;
      this.$store.dispatch("SET_COLLAPSE", !this.isCollapse);
    },
    // 实时检测刷新token
    refreshToken() {
      this.refreshTime = setInterval(() => {
        const token = getStore({
          name: "token",
          debug: true,
        });
        const date = calcDate(token.datetime, new Date().getTime());
        if (validatenull(date)) return;
        if (!(date.seconds >= this.website.tokenTime) && !this.refreshLock) {
          this.refreshLock = true;
          this.$store
            .dispatch("RefeshToken")
            .then(() => {
              clearInterval(this.refreshTime);
            })
            .catch(() => {
              this.refreshLock = false;
            });
        }
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.avue-contail {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  background-size: 100%;
  background-repeat: no-repeat;
}
footer {
  height: 30px !important;
}
.avue-layout,
.avue-top {
  min-width: 1300px;
  width: 98%;
  height: 100%;
  margin: 0 auto;
}
.avue-left {
  // 过渡效果
  transition: width 0.3s !important;
  width: 200px !important;
}
.avue-sidebar {
  height: 100%;
}
.avue-header {
  background: #fff;
  min-width: 1300px;
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.3);
  margin-bottom: 10px;
}
.avue-main {
  padding: 0;
  position: relative;
  height: calc(100% - 8px);
  box-sizing: border-box;
  overflow: hidden;
}
.avue-view {
  padding-bottom: 22px;
  width: 100%;
  box-sizing: border-box;
}
.avue-footer {
  margin: 0 auto;
  padding: 0 22px;
  width: 1300px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    margin-left: -50px;
  }
  .copyright {
    color: #666;
    line-height: 1.5;
    font-size: 12px;
  }
}
</style>
